import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import ReactPaginate from 'react-paginate'
import Notifications from 'react-notification-system-redux'

import { ConfirmDialog } from '../../../common/confirm_dialog'
import * as formatters from '../../../common/formatters'
import { url, handleCommonListActions, getListItemsCountMessage, getPrerequisitesArray } from '../../../common/helpers'

import { prepareTableActionCreators } from '../../../common/table/actionCreators'
import { TableSortButtons, TableFilterInputField, TableFilterSelectField, TableFilterBooleanField } from '../../../common/table/components'
import { getActiveFilters, getTotalNumberOfPages } from '../../../common/table/helpers'
import { TableModelColumn, TableModelColumnType, TableModelColumnFilteringType } from '../../../common/table/model'
import { createTableDataSelector, createTableModelSelector } from '../../../common/table/selectors'

import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'

import * as countriesActionCreators from '../actionCreators'
import { getCountries, getCountryDeleting, getCountryDeleteError } from '../selectors'
import { createGetCurrencyByIDSelector } from '../../currencies/selectors'

import { PERMS } from '../permissions'

import CountriesListRow from './CountriesListRow'
import PermissionsCheck from '../../auth/components/PermissionsCheck'

const tableIdentifier = 'countries_list'
const clientSideItemsPerPage = undefined

const componentIdentifier = 'countries_list'
const prerequisites = ['currencies']

const columns = {
    name: new TableModelColumn({}),
    iso_code: new TableModelColumn({}),
    iso_code_2: new TableModelColumn({}),
    toll_per_km: new TableModelColumn({
        type: TableModelColumnType.float,
    }),
    toll_per_day: new TableModelColumn({
        type: TableModelColumnType.float,
    }),
    minimum_hour_wage: new TableModelColumn({
        type: TableModelColumnType.float,
    }),
}

class CountriesList extends Component {
    state = {
        confirmDialog: {
            show: false,
            title: '',
            message: '',
            labelCancel: '',
            labelAccept: '',
            classNameAccept: 'text-success',
            classNameCancel: 'text-default',
            onCancel: () => {},
            onAccept: () => {},
        },
    }

    // confirm dialog
    showConfirmDialog = options => {
        this.setState({
            confirmDialog: {
                show: true,
                title: options.title || this.props.intl.formatMessage({ id: 'confirmDialog.default.title' }),
                message: options.message || this.props.intl.formatMessage({ id: 'confirmDialog.default.message' }),
                labelCancel: options.labelCancel || this.props.intl.formatMessage({ id: 'confirmDialog.default.cancel' }),
                labelAccept: options.labelAccept || this.props.intl.formatMessage({ id: 'confirmDialog.default.accept' }),
                classNameAccept: options.classNameAccept || 'btn-success',
                classNameCancel: options.classNameCancel || 'btn-default',
                onCancel: options.onCancel || this.hideConfirmDialog,
                onAccept: options.onAccept || this.hideConfirmDialog,
            },
        })
    }

    hideConfirmDialog = () => {
        this.setState({
            confirmDialog: {
                show: false,
                onCancel: () => {},
                onAccept: () => {},
            },
        })
    }

    // handlers
    onClick = itemId => {
        this.props.redirect(`/countries/${itemId}`)
    }

    onDelete = itemId => {
        this.showConfirmDialog({
            title: this.props.intl.formatMessage({ id: 'confirmDialog.delete.title' }),
            message: this.props.intl.formatMessage({ id: 'confirmDialog.delete.message' }),
            labelCancel: this.props.intl.formatMessage({ id: 'confirmDialog.delete.cancel' }),
            labelAccept: this.props.intl.formatMessage({ id: 'confirmDialog.delete.accept' }),
            classNameAccept: 'btn-danger',
            onAccept: () => {
                this.props.actions.deleteCountry(itemId)
                this.hideConfirmDialog()
            },
        })
    }

    handleExport = e => {
        e && e.preventDefault()
        this.props.actions.exportCountries(this.props.tableModel.get('filters').toJS(), this.props.tableModel.get('sorting').toJS())
    }

    refresh = () => {
        this.props.actions.fetchCountries()
    }

    resetFilters = () => {
        this.props.table.resetFilters()
    }

    isFilterActive = () => getActiveFilters(this.props.tableModel).size > 0

    componentDidMount() {
        this.props.actions.fetchCountries()
        this.props.actions.fetchPrerequisites()
    }

    componentWillReceiveProps(nextProps) {
        handleCommonListActions(this.props, nextProps)
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.countries.heading' }))

        const sorting = this.props.tableModel.get('sorting')
        const filters = this.props.tableModel.get('filters')

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className="page-inner">
                    <div id="main-wrapper">
                        <div className="panel panel-white">
                            <div className="panel-body">
                                <h4>
                                    <FormattedMessage id="modules.countries.heading" />
                                </h4>

                                <div className="btns-list">
                                    {this.isFilterActive() > 0 && (
                                        <button className="btn btn-default btn-addon m-r-xs" onClick={this.resetFilters}>
                                            <i className="far fa-times" /> <FormattedMessage id="buttons.resetFilters" />
                                        </button>
                                    )}
                                    <button className="btn btn-default btn-addon m-r-xs" onClick={this.refresh}>
                                        <i className="far fa-sync-alt" /> <FormattedMessage id="buttons.refresh" />
                                    </button>
                                    <PermissionsCheck has={[PERMS.EXPORT]}>
                                        <button className="btn btn-primary btn-addon m-r-xs" onClick={this.handleExport}>
                                            <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                        </button>
                                    </PermissionsCheck>
                                    <PermissionsCheck has={[PERMS.CREATE]}>
                                        <Link to={url(this.props.match, 'countries/new')} className="btn btn-addon btn-success">
                                            <i className="far fa-plus" /> <FormattedMessage id="buttons.createItem" />
                                        </Link>
                                    </PermissionsCheck>
                                </div>

                                <div className="table-container">
                                    <table className="table table-striped table-hover table-fixed-header">
                                        <thead>
                                            <tr>
                                                <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                                                    <th className="w-60" />
                                                </PermissionsCheck>
                                                <th className="w-120">
                                                    <FormattedMessage id="fields.isoCode3" />
                                                    <TableSortButtons
                                                        identifier="iso_code"
                                                        sorting={sorting}
                                                        onChange={this.props.table.changeSorting}
                                                    />
                                                </th>
                                                <th className="w-120">
                                                    <FormattedMessage id="fields.isoCode2" />
                                                    <TableSortButtons
                                                        identifier="iso_code_2"
                                                        sorting={sorting}
                                                        onChange={this.props.table.changeSorting}
                                                    />
                                                </th>
                                                <th className="w-max wm-300">
                                                    <FormattedMessage id="fields.name" />
                                                    <TableSortButtons identifier="name" sorting={sorting} onChange={this.props.table.changeSorting} />
                                                </th>
                                                <th className="w-160">
                                                    <FormattedMessage id="fields.currency" />
                                                </th>
                                                <th className="w-100 text-right">
                                                    <FormattedMessage id="fields.exchangeRate" />
                                                </th>
                                                <th className="w-160 text-right">
                                                    <FormattedMessage id="fields.tollPerKm" />
                                                    <TableSortButtons
                                                        identifier="toll_per_km"
                                                        sorting={sorting}
                                                        onChange={this.props.table.changeSorting}
                                                    />
                                                </th>
                                                <th className="w-160 text-right">
                                                    <FormattedMessage id="fields.tollPerDay" />
                                                    <TableSortButtons
                                                        identifier="toll_per_day"
                                                        sorting={sorting}
                                                        onChange={this.props.table.changeSorting}
                                                    />
                                                </th>
                                                <th className="w-160 text-right">
                                                    <FormattedMessage id="fields.minimumHourWage" />
                                                    <TableSortButtons
                                                        identifier="minimum_hour_wage"
                                                        sorting={sorting}
                                                        onChange={this.props.table.changeSorting}
                                                    />
                                                </th>
                                                <th className="w-80 text-center">
                                                    <FormattedMessage id="fields.inEU" />
                                                </th>
                                            </tr>
                                            <tr className="filters">
                                                <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                                                    <th className="w-60" />
                                                </PermissionsCheck>
                                                <th className="w-120">
                                                    <TableFilterInputField
                                                        identifier="iso_code"
                                                        type={TableModelColumnFilteringType.stringFromStart}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-120">
                                                    <TableFilterInputField
                                                        identifier="iso_code_2"
                                                        type={TableModelColumnFilteringType.stringFromStart}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-max wm-300">
                                                    <TableFilterInputField
                                                        identifier="name"
                                                        type={TableModelColumnFilteringType.string}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-160">
                                                    <TableFilterSelectField
                                                        identifier="currency_id"
                                                        type={TableModelColumnFilteringType.equal}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                        values={getPrerequisitesArray(
                                                            this.props.prerequisites.values.get('currencies'),
                                                            'id',
                                                            'iso_code'
                                                        )}
                                                    />
                                                </th>
                                                <th className="w-100" />
                                                <th className="w-160">
                                                    <TableFilterInputField
                                                        identifier="toll_per_km"
                                                        type={TableModelColumnFilteringType.stringFromStart}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-160">
                                                    <TableFilterInputField
                                                        identifier="toll_per_day"
                                                        type={TableModelColumnFilteringType.stringFromStart}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-160">
                                                    <TableFilterInputField
                                                        identifier="minimum_hour_wage"
                                                        type={TableModelColumnFilteringType.stringFromStart}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                                <th className="w-80">
                                                    <TableFilterBooleanField
                                                        identifier="is_in_eu"
                                                        type={TableModelColumnFilteringType.equal}
                                                        filters={filters}
                                                        onChange={this.props.table.changeFilter}
                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.countries.data.valueSeq().map(row => (
                                                <CountriesListRow
                                                    key={`row-${row.id}`}
                                                    data={row}
                                                    onClick={this.onClick}
                                                    onDelete={this.onDelete}
                                                    currency={this.props.createGetCurrencyByIDSelector(row.currency_id)}
                                                />
                                            ))}
                                        </tbody>
                                    </table>

                                    <div className="pull-left m-l-xxs m-t-md">
                                        <FormattedMessage id="pagination.totalRecords" />:{' '}
                                        {getListItemsCountMessage(
                                            clientSideItemsPerPage,
                                            this.props.countries.count,
                                            this.props.tableModel.getIn(['pagination', 'totalCount'])
                                        )}
                                    </div>

                                    <ReactPaginate
                                        containerClassName="pagination"
                                        breakLabel={<span className="disabled">...</span>}
                                        activeClassName="active"
                                        pageCount={getTotalNumberOfPages(this.props.tableModel, this.props.countries.count, clientSideItemsPerPage)}
                                        pageRangeDisplayed={10}
                                        marginPagesDisplayed={2}
                                        forcePage={this.props.tableModel.getIn(['pagination', 'current'])}
                                        onPageChange={this.props.table.changePage}
                                        previousLabel={this.props.intl.formatMessage({ id: 'pagination.previous' })}
                                        nextLabel={this.props.intl.formatMessage({ id: 'pagination.next' })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ConfirmDialog options={this.state.confirmDialog} />
                </div>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state) {
    return {
        countries: createTableDataSelector({
            tableIdentifier,
            columns,
            dataSelector: getCountries,
            clientSideItemsPerPage,
        })(state),
        tableModel: createTableModelSelector(tableIdentifier)(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
        deleting: getCountryDeleting(state),
        deleteError: getCountryDeleteError(state),
        createGetCurrencyByIDSelector: id => createGetCurrencyByIDSelector(id)(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...countriesActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
        redirect: toURL => dispatch(push(toURL)),
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        table: bindActionCreators(prepareTableActionCreators(tableIdentifier, stateProps.tableModel), dispatchProps.dispatch),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(CountriesList)
)
